export const FORM_MAX_LENGTH = {
  /** Single-line inputs. */
  DEFAULT: 255,
  /** Textareas and other multi-line free text. */
  LARGE: 500,
} as const;
